module.exports = __webpack_public_path__ + "img/_MARISOL--icono-2.e65dfbc1.gif";